import { BaseModel } from '../../base/base-model'

/**
 * @memberOf loavies.models.listing
 * @constructor
 */
export class ListingPriceFilter extends BaseModel {
  /**
   * @param {string} key
   * @param {string} type
   * @param {string} field
   * @param {number} amount
   */
  constructor({
    key,
    type,
    field,
    amount,
  }) {
    super()

    /** @type {string} */
    this.key = key

    /** @type {string} */
    this.type = type

    /** @type {string} */
    this.field = field

    /** @type {number} */
    this.amount = amount
  }
}
